import axios from "axios";
import { getToken, removeStorage } from "@/utils/auth";
import router from "@/router";
import { Message } from "element-ui";
import { apiTest } from "@/config";

var qs = require("qs");
// import Cache from "@/utils/cache";

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = apiTest;
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.token =
      config.url.indexOf("cyIndex/jobs/list") > -1 ? " " : getToken();
    if (config.url.indexOf("processConfig/powerProcDefList") > -1) {
      config.headers.token = sessionStorage.getItem("otherToken");
    }
    return config;
  },
  (error) => Promise.reject(error)
);
const arr = [
  "queryShipStaticInfoByMmsi",
  "queryShipPositions",
  "userDetailList",
  "saveHsjPublicSystemOpen",
  // "saveCreditViolateRecord",
  "hsjAuditShipPhoto",
  // "loadCompanyShips.action",
  "loadTzMsaCompanyShips",
  "selectTzMsaShipNumStatis",
  "msaIsmShipPhotoDetailByBaseShipId",
  "saveHsjShipTrackOutRecord",
  "targetSearch.action",
  "saveHsjVideoCheck",
  "noticeTitleAllList",
  "saveNoticeTitle",
  "editNoticeTitle",
  "delSendNoticeTitle",
  "readCompany",
  "unReadCompany",
  "taiwanAccountCfg",
  "ledgerListByCompanyId",
  "ledgerDetail",
  "updateHsjVideoCheck",
  "loadShipTrackNew",
  "queryShipPortByMmsi",
  "shipTipBind",
];
// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    for (let i = 0; i < arr.length; i++) {
      if (response.request.responseURL.indexOf(arr[i]) > -1) {
        return response.data;
      }
    }
    /** http://198.16.1.120:8889 返回的接口为 code = 1 */
    if (response.data.code === 1) {
      return response.data;
    }
    /** http://198.16.1.177:8888 返回的接口为 code = 1 */
    if (response.data.code === 200) {
      return response.data || response.data.body;
    }
    /* 10000为token过期或者未登录 */
    if (response.data.errorCode === "10000") {
      removeStorage();
      router.push("/login");
    } else if (response.data.code === 500 || response.data.code === 3006) {
      Message.error({
        content: response.data.msg,
        duration: 1,
      });
      // return Promise.reject(new Error(response.data.msg || "Error"));
    } else if (response.data.code === 0) {
      console.log(response);
      return response.data || response.data.body;
      // return Promise.reject(new Error(response.data.msg || "Error"));
    } else {
      return response.data || response.data.body;
      // Message.error({
      //   content: response.data.msg,
      //   duration: 1,
      // });
      // return Promise.reject(new Error(response.data.msg || "Error"));
    }
  },
  (error) => {
    // // 请求拦截器中的source.cancel会将内容发送到error中
    // // 通过axios.isCancel(error)来判断是否返回有数据 有的话直接返回给用户
    // if (axios.isCancel(error)) {
    //   return Promise.resolve(error.message);
    // }

    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          console.log(`错误请求`);
          break;
        case 401:
          console.log(`未授权请重新登陆`);
          break;
        case 403:
          console.log(`拒绝访问`);
          break;
        case 404:
          console.log(`请求错误`);
          break;
        case 405:
          console.log(`请求方法未允许`);
          break;
        case 408:
          console.log(`请求超时`);
          break;
        case 501:
          console.log(`网络未实现`);
          break;
        case 502:
          console.log(`网络错误`);
          break;
        case 503:
          console.log(`服务器不可用`);
          break;
        case 504:
          console.log(`网络超时`);
          break;
        case 505:
          console.log(`版本不支持该请求`);
          break;
        default:
          console.log(`default`);
          break;
      }
    } else {
      console.log(`连接错误${error.response.status}`);
    }

    return Promise.reject("");
  }
);

export const get = (path, params = {}, config = {}) => {
  return axiosInstance.get(path, { params, ...config });
};
/**
 *
 * @param {string} path
 * @param {object} data
 * @param {{__normal:boolean,[key:string]:any}} config
 */
export const post = (path, data = {}, config = {}) => {
  // __normal: true   post传参
  if (config.__normal) {
    config.headers = {
      "content-type": "application/x-www-form-urlencoded",
    };

    // console.log(path);
    if (
      path.indexOf("cyIndex/jobs/list") > -1 ||
      path.indexOf("selectProvinceList") > -1 ||
      path.indexOf("selectCitesByProvCode") > -1 ||
      path.indexOf("selectAreaByCityCode") > -1
    ) {
      config.headers = {
        "content-type": "application/x-www-form-urlencoded",
      };
    }
    data = qs.stringify(data);
    delete config.__normal;
  } else if (config.upload) {
    config.headers = {
      "content-type": "multipart/form-data",
    };
    delete config.upload;
  } else {
    config.headers = {
      "content-type": "application/json",
    };
    data = JSON.stringify(data);
  }

  return axiosInstance.post(path, data, config);
};
/*
  单文件上传
 */
export const singleUpload = (path, fileList, config = {}) => {
  config.headers = {
    "Content-Type": undefined,
  };
  let data = new FormData(); // 表单格式
  data.append("uploadFiles", fileList[0].originFileObj); // 添加file表单数据
  return axiosInstance.post(path, data, config);
};
/*
  多文件上传
 */
export const multiUpload = (path, fileList, config = {}) => {
  config.headers = {
    "Content-Type": undefined,
  };
  let data = new FormData(); // 表单格式
  fileList.forEach((file) => {
    data.append("uploadFileList", file.originFileObj);
  });
  return axiosInstance.post(path, data, config);
};
